// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsorship-container {
  font-family: Arial, sans-serif;
  background: linear-gradient(to bottom right, #f9faf9, #e6f4ec);
  min-height: 100vh;
}

/* Hero */
.sponsor-hero {
  text-align: center;
  padding: 3rem 2rem 2rem;
}

.sponsorship-title {
  font-size: 2.4rem;
  color: #004225;
  margin-bottom: 0.75rem;
  font-weight: bold;
}

.sponsorship-subtitle {
  font-size: 1.1rem;
  color: #555;
  max-width: 680px;
  margin: 0 auto;
  line-height: 1.7;
}

/* Why sponsor */
.why-sponsor {
  text-align: center;
  padding: 2rem 2rem 1rem;
}

.why-sponsor h2 {
  font-size: 1.8rem;
  color: #004225;
  margin-bottom: 1.5rem;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.25rem;
  max-width: 900px;
  margin: 0 auto;
}

.why-card {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  transition: transform 0.2s;
}

.why-card:hover { transform: translateY(-3px); }

.why-card span {
  font-size: 2rem;
  display: block;
  margin-bottom: 0.5rem;
}

.why-card h4 {
  color: #00703C;
  font-size: 1rem;
  margin: 0 0 0.4rem;
}

.why-card p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* Tiers */
.tiers-section {
  text-align: center;
  padding: 2rem;
}

.tiers-section h2 {
  font-size: 1.8rem;
  color: #004225;
  margin-bottom: 0.5rem;
}

.tiers-sub {
  color: #666;
  margin-bottom: 1.5rem;
}

.tiers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;
  max-width: 1000px;
  margin: 0 auto;
}

.tier-card {
  background: #fff;
  border-radius: 14px;
  padding: 1.75rem 1.25rem;
  box-shadow: 0 3px 10px rgba(0,0,0,0.08);
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tier-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0,64,32,0.13);
}

.tier-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.tier-name {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0.25rem 0;
}

.tier-amount {
  font-size: 1rem;
  color: #444;
  font-weight: 600;
  margin-bottom: 1rem;
}

.tier-perks {
  list-style: none;
  padding: 0;
  margin: 0 0 1.25rem;
  text-align: left;
  width: 100%;
}

.tier-perks li {
  font-size: 0.88rem;
  color: #555;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.tier-perks li:last-child { border-bottom: none; }

.tier-select-btn {
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.6rem 1.4rem;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  transition: opacity 0.2s;
  margin-top: auto;
}

.tier-select-btn:hover { opacity: 0.88; }

/* Form section */
.sponsor-form-section {
  max-width: 680px;
  margin: 0 auto;
  padding: 2rem 2rem 3rem;
  text-align: center;
}

.sponsor-form-section h2 {
  font-size: 1.8rem;
  color: #004225;
  margin-bottom: 0.5rem;
}

.form-intro {
  color: #666;
  margin-bottom: 1.75rem;
}

.sponsor-form {
  background: #fff;
  border-radius: 14px;
  padding: 2rem;
  box-shadow: 0 3px 12px rgba(0,0,0,0.08);
  text-align: left;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 1rem;
}

.form-field label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}

.form-field input,
.form-field select,
.form-field textarea {
  padding: 0.7rem 0.85rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s;
  font-family: Arial, sans-serif;
  box-sizing: border-box;
  width: 100%;
}

.form-field input:focus,
.form-field select:focus,
.form-field textarea:focus {
  border-color: #00703C;
}

.form-field input.error,
.form-field select.error {
  border-color: #dc3545;
}

.field-error {
  font-size: 12px;
  color: #dc3545;
}

.form-field textarea { resize: vertical; }

.submit-sponsor-btn {
  width: 100%;
  padding: 0.85rem;
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.5rem;
}

.submit-sponsor-btn:hover:not(:disabled) { background: #005a30; }
.submit-sponsor-btn:disabled { background: #ccc; cursor: not-allowed; }

.form-note {
  font-size: 13px;
  color: #888;
  text-align: center;
  margin-top: 1rem;
}

.form-note a { color: #00703C; }

/* Success */
.sponsor-success {
  background: #fff;
  border-radius: 14px;
  padding: 3rem 2rem;
  box-shadow: 0 3px 12px rgba(0,0,0,0.08);
  text-align: center;
}

.success-icon { font-size: 3rem; margin-bottom: 1rem; }

.sponsor-success h3 {
  font-size: 1.5rem;
  color: #004225;
  margin-bottom: 0.75rem;
}

.sponsor-success p {
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.send-another-btn {
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.6rem;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.send-another-btn:hover { background: #005a30; }

/* Responsive */
@media (max-width: 600px) {
  .form-row { grid-template-columns: 1fr; }
  .sponsor-form { padding: 1.25rem; }
  .sponsorship-title { font-size: 1.8rem; }
}`, "",{"version":3,"sources":["webpack://./src/pages/Sponsorship.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8DAA8D;EAC9D,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,kBAAkB,2BAA2B,EAAE;;AAE/C;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gCAAgC;AAClC;;AAEA,4BAA4B,mBAAmB,EAAE;;AAEjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,yBAAyB,aAAa,EAAE;;AAExC,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,2CAA2C,mBAAmB,EAAE;AAChE,+BAA+B,gBAAgB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe,cAAc,EAAE;;AAE/B,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;;AAEtD;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C,eAAe;AACf;EACE,YAAY,0BAA0B,EAAE;EACxC,gBAAgB,gBAAgB,EAAE;EAClC,qBAAqB,iBAAiB,EAAE;AAC1C","sourcesContent":[".sponsorship-container {\n  font-family: Arial, sans-serif;\n  background: linear-gradient(to bottom right, #f9faf9, #e6f4ec);\n  min-height: 100vh;\n}\n\n/* Hero */\n.sponsor-hero {\n  text-align: center;\n  padding: 3rem 2rem 2rem;\n}\n\n.sponsorship-title {\n  font-size: 2.4rem;\n  color: #004225;\n  margin-bottom: 0.75rem;\n  font-weight: bold;\n}\n\n.sponsorship-subtitle {\n  font-size: 1.1rem;\n  color: #555;\n  max-width: 680px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n/* Why sponsor */\n.why-sponsor {\n  text-align: center;\n  padding: 2rem 2rem 1rem;\n}\n\n.why-sponsor h2 {\n  font-size: 1.8rem;\n  color: #004225;\n  margin-bottom: 1.5rem;\n}\n\n.why-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.25rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.why-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem 1rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.07);\n  transition: transform 0.2s;\n}\n\n.why-card:hover { transform: translateY(-3px); }\n\n.why-card span {\n  font-size: 2rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.why-card h4 {\n  color: #00703C;\n  font-size: 1rem;\n  margin: 0 0 0.4rem;\n}\n\n.why-card p {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Tiers */\n.tiers-section {\n  text-align: center;\n  padding: 2rem;\n}\n\n.tiers-section h2 {\n  font-size: 1.8rem;\n  color: #004225;\n  margin-bottom: 0.5rem;\n}\n\n.tiers-sub {\n  color: #666;\n  margin-bottom: 1.5rem;\n}\n\n.tiers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.tier-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.75rem 1.25rem;\n  box-shadow: 0 3px 10px rgba(0,0,0,0.08);\n  text-align: center;\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tier-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0,64,32,0.13);\n}\n\n.tier-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.tier-name {\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin: 0.25rem 0;\n}\n\n.tier-amount {\n  font-size: 1rem;\n  color: #444;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.tier-perks {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.25rem;\n  text-align: left;\n  width: 100%;\n}\n\n.tier-perks li {\n  font-size: 0.88rem;\n  color: #555;\n  padding: 4px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.tier-perks li:last-child { border-bottom: none; }\n\n.tier-select-btn {\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.6rem 1.4rem;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  transition: opacity 0.2s;\n  margin-top: auto;\n}\n\n.tier-select-btn:hover { opacity: 0.88; }\n\n/* Form section */\n.sponsor-form-section {\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 2rem 2rem 3rem;\n  text-align: center;\n}\n\n.sponsor-form-section h2 {\n  font-size: 1.8rem;\n  color: #004225;\n  margin-bottom: 0.5rem;\n}\n\n.form-intro {\n  color: #666;\n  margin-bottom: 1.75rem;\n}\n\n.sponsor-form {\n  background: #fff;\n  border-radius: 14px;\n  padding: 2rem;\n  box-shadow: 0 3px 12px rgba(0,0,0,0.08);\n  text-align: left;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 1rem;\n}\n\n.form-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n}\n\n.form-field input,\n.form-field select,\n.form-field textarea {\n  padding: 0.7rem 0.85rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s;\n  font-family: Arial, sans-serif;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.form-field input:focus,\n.form-field select:focus,\n.form-field textarea:focus {\n  border-color: #00703C;\n}\n\n.form-field input.error,\n.form-field select.error {\n  border-color: #dc3545;\n}\n\n.field-error {\n  font-size: 12px;\n  color: #dc3545;\n}\n\n.form-field textarea { resize: vertical; }\n\n.submit-sponsor-btn {\n  width: 100%;\n  padding: 0.85rem;\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.5rem;\n}\n\n.submit-sponsor-btn:hover:not(:disabled) { background: #005a30; }\n.submit-sponsor-btn:disabled { background: #ccc; cursor: not-allowed; }\n\n.form-note {\n  font-size: 13px;\n  color: #888;\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.form-note a { color: #00703C; }\n\n/* Success */\n.sponsor-success {\n  background: #fff;\n  border-radius: 14px;\n  padding: 3rem 2rem;\n  box-shadow: 0 3px 12px rgba(0,0,0,0.08);\n  text-align: center;\n}\n\n.success-icon { font-size: 3rem; margin-bottom: 1rem; }\n\n.sponsor-success h3 {\n  font-size: 1.5rem;\n  color: #004225;\n  margin-bottom: 0.75rem;\n}\n\n.sponsor-success p {\n  color: #555;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.send-another-btn {\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.7rem 1.6rem;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.send-another-btn:hover { background: #005a30; }\n\n/* Responsive */\n@media (max-width: 600px) {\n  .form-row { grid-template-columns: 1fr; }\n  .sponsor-form { padding: 1.25rem; }\n  .sponsorship-title { font-size: 1.8rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
